<script lang="ts" setup>
import { inject, onBeforeMount } from "vue";
import { storeToRefs } from "pinia";

import { useBroadcast } from "~/stores/broadcast.store";
import StatisticsList from "~/components/statistics/StatisticsList.vue";
import { AppStateT } from "~/main";

const appState: AppStateT = inject("state")!;

const { loadStatistics, setFetching } = useBroadcast();

const { statistics, isFetching } = storeToRefs(useBroadcast());

onBeforeMount(async () => {
  appState.isLoading = true;

  await loadStatistics();

  appState.isLoading = false;
});
</script>

<template>
  <div class="loader-wrapper" v-if="isFetching">
    <BasePreloader class="preloader" />
  </div>

  <div v-else class="broadcast-wrapper">
    <template v-if="statistics.length">
      <div class="broadcast-content">
        <StatisticsHeader />
        <StatisticsList />
      </div>
    </template>
    <EmptyStatistics v-else />
  </div>
</template>

<style scoped>
.loader-wrapper {
  height: 100%;
  position: relative;

  .preloader {
    margin: auto;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }
}

.broadcast-wrapper {
  background-color: var(--ui-white);
  height: calc(100vh - 64px);
  padding: 16px;
  overflow-y: auto;
}

.broadcast-content {
  box-sizing: border-box;
  padding: 16px 24px 4px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>
